// extracted by mini-css-extract-plugin
export var card = "_iu-5";
export var cardSelected = "_iu-4";
export var image = "_iu-3";
export var modal = "_iu-0";
export var modalContent = "_iu-1";
export var table = "_iu-2";